module.exports = __webpack_public_path__ + "static/media/Rachit_Mehrotra_20210713_PCA - JavaScript Certification.42352ddd.jpg";